import checkValidOp from "./checkValidOp";

function applyError(msg, op) {
  throw new Error(msg + ` in op: ${JSON.stringify(op)}`);
}

// Apply the op to the snapshot. Snapshot is modified in place.
function apply(snapshot, op) {
  checkValidOp(op);

  for (const c of op) {
    if (!Array.isArray(c.p)) {
      applyError("Path must be an array", c);
    }
    let table = c.p[0];
    if (!table || typeof table !== "string") {
      applyError("Missing or invalid table in path", c);
    }

    let objectId = null;
    if (
      c.hasOwnProperty("co") ||
      c.hasOwnProperty("do") ||
      c.hasOwnProperty("cp")
    ) {
      objectId = c.p[1];
      if (!objectId) {
        applyError("ObjectID missing", c);
      }
    }

    if (c.hasOwnProperty("co")) {
      // Object create. Ensure the table exists before we write to it.
      if (snapshot[table] && typeof snapshot[table] !== "object") {
        applyError("Table has wrong type", c);
      }
      if (!snapshot[table]) {
        snapshot[table] = {};
      }
      snapshot[table][objectId] = c.co;
    } else if (c.hasOwnProperty("do")) {
      // Object delete
      if (!snapshot[table] || typeof snapshot[table] !== "object") {
        applyError("Table not found", c);
      }
      delete snapshot[table][objectId];
    } else if (c.hasOwnProperty("cp")) {
      // Update property
      let object = snapshot[table][objectId];
      if (!object) {
        applyError("Object not found", c);
      }
      if (c.p.length < 3 || !c.p[2]) {
        applyError("Property not specified", c);
      }

      // Navigate to the property, creating sub-objects as needed.
      for (let i = 2; i < c.p.length - 1; i++) {
        if (
          !(c.p[i] in object) ||
          object[c.p[i]] === null ||
          object[c.p[i]] === undefined
        ) {
          object[c.p[i]] = {};
        } else if (typeof object[c.p[i]] !== "object") {
          applyError(
            `Attempt to apply sub-property to non-object ${JSON.stringify(
              object[c.p[i]]
            )}`,
            c
          );
        }
        object = object[c.p[i]];
      }
      const property = c.p[c.p.length - 1];

      if (c.cp === null) {
        delete object[property];
      } else {
        object[property] = c.cp;
      }
    } else if (c.hasOwnProperty("cs")) {
      if (c.p[1] > snapshot.stack.length || c.p[1] < 0) {
        applyError(
          `Stack insert out of range ${c.p[1]} len=${snapshot.stack.length}`,
          c
        );
      }

      // Insert into stack
      snapshot.stack.splice(c.p[1], 0, c.cs);
    } else if (c.hasOwnProperty("ds")) {
      if (snapshot.stack[c.p[1]] !== c.ds) {
        applyError(
          `Stack entry not as expected ${snapshot.stack[c.p[1]]} !== ${c.ds}`,
          c
        );
      }
      // Delete from stack
      snapshot.stack.splice(c.p[1], 1);
    }
  }

  return snapshot;
}

export default apply;
